module.exports = __webpack_public_path__ + "f71b314abb59e42bb4b35ded5472fb14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mshlg.png
// module id = 259
// module chunks = 1